module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("lcNgi"))).then(() => parcelRequire('5hLCD'));